import { render, staticRenderFns } from "./AiChatModal.vue?vue&type=template&id=708c089a&scoped=true&"
import script from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiChatModal.vue?vue&type=style&index=0&id=708c089a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c089a",
  null
  
)

export default component.exports